import { ORDER_EXCHANGE as type } from '../actions/orderExchangeTypes';

const initialState = {
    queryTaskListLoading: false,
    queryTaskList: [],
    queryTaskListError: false,
    queryToBeForwardOrdersLoading: false,
    queryToBeForwardOrders: [],
    queryToBeForwardOrdersError: false,
    queryTaskDetailLoading: false,
    queryTaskDetail: [],
    queryTaskDetailError: false
}

export default function orderExchangeReducer(state = initialState, action){
    switch(action.type){
        case type.QUERY_TASK_DETAIL:
            return {
                ...state,
                queryTaskDetailLoading: true
            }
        case type.QUERY_TASK_DETAIL_SUCCESS:
            return {
                ...state,
                queryTaskDetail: action.payload, 
                queryTaskDetailLoading: false      
            }
        case type.QUERY_TASK_DETAIL_FAIL:
            return {
                ...state,
                queryTaskDetail: initialState.queryTaskList,
                queryTaskDetailLoading: false,
                queryTaskDetailError: action.payload
            }
        case type.QUERY_TASK_LIST:
            return {
                ...state,
                queryTaskListLoading: true
            }
        case type.QUERY_TASK_LIST_SUCCESS:
            return {
                ...state,
                queryTaskList: action.payload, 
                queryTaskListLoading: false      
            }
        case type.QUERY_TASK_LIST_FAIL:
            return {
                ...state,
                queryTaskList: initialState.queryTaskList,
                queryTaskListLoading: false,
                queryTaskListError: action.payload
            }
        case type.QUERY_TO_BE_FORWARD_ORDERS:
            return {
                ...state,
                queryToBeForwardOrdersLoading: true
            }
        case type.QUERY_TO_BE_FORWARD_ORDERS_SUCCESS:
            return {
                ...state,
                queryToBeForwardOrders: action.payload, 
                queryToBeForwardOrdersLoading: false      
            }
        case type.QUERY_TO_BE_FORWARD_ORDERS_FAIL:
            return {
                ...state,
                queryToBeForwardOrders: initialState.queryToBeForwardOrders, 
                queryToBeForwardOrdersLoading: false,
                queryToBeForwardOrdersError: action.payload 
            }
        default:
            return state;
    }
}